import { render } from "./AuszahlungBetragBoxBetragAndDifferenz.pug?vue&type=template&id=51c69ebc&lang=pug"
import script from "./AuszahlungBetragBoxBetragAndDifferenz.js?vue&type=script&lang=js"
export * from "./AuszahlungBetragBoxBetragAndDifferenz.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__